module.exports = __webpack_public_path__ + "static/media/SocialImage.a3536f78.png";